// =====================================================
// 📁 quotationHistoryFilters.ts
// =====================================================

import { FilterConfig } from "../../../components/Tables/advancedRecord/FilterBar";
import { DropdownDTO } from "../../../types/common/DropdownDTO";


export const getQuotationHistoryFilters = (
  customersDropdown: DropdownDTO[],
  employeeDropdown: DropdownDTO[],
): FilterConfig[] => {

  return [

    // =====================================================
    // 🔹 Cotización
    // =====================================================

    {
      name: 'quotationNumber',

      label: 'Número Cotización',

      type: 'text',

      colSpan: 2,
    },

    // =====================================================
    // 🔹 Cliente
    // =====================================================

    {
      name: 'customerId',

      label: 'Cliente',

      type: 'searchSelect',

      options: customersDropdown,

      colSpan: 3,
    },

    // =====================================================
    // 🔹 Vendedor
    // =====================================================

    {
      name: 'sellerId',

      label: 'Vendedor',

      type: 'searchSelect',

      options: employeeDropdown,

      colSpan: 3,
    },

    // =====================================================
    // 🔹 Estado
    // =====================================================

    {
      name: 'status',

      label: 'Estado',

      type: 'select',

      options: [

        {
          id: 'ACTIVE',
          name: 'Activa',
        },

        {
          id: 'CANCELLED',
          name: 'Cancelada',
        },

        {
          id: 'EXPIRED',
          name: 'Expirada',
        },

        // {
        //   id: 'PROCESSED',
        //   name: 'Procesada',
        // },

      ],

      colSpan: 2,
    },

    // =====================================================
    // 🔹 Fecha
    // =====================================================

    {
      name: 'quotationDate',

      label: 'Fecha Cotización',

      type: 'date',

      colSpan: 2,
    },

    // =====================================================
    // 🔹 Total
    // =====================================================

    {
      name: 'total',

      label: 'Total',

      type: 'number',

      colSpan: 2,
    },

  ];

};